import { useState } from 'react';
import { Link } from 'react-router';

import { AboutDialog } from '@/components/regulatory/about-dialog';
import { cn } from '@/lib/utils';

/**
 * Persistent footer with the mandated document links (ESCLOUD-77/78 —
 * SDS ESCLOUD-181). Rendered by every layout except FullscreenLayout: the
 * immersive case viewer deliberately carries no chrome, and the documents
 * stay one navigation away on every footer-bearing screen.
 */
export function LegalFooter({ className }: { className?: string }) {
    const [aboutOpen, setAboutOpen] = useState(false);

    const linkClasses = 'transition-colors hover:text-foreground hover:underline';

    return (
        <footer className={cn('shrink-0 border-t bg-background px-4 py-1.5', className)}>
            <nav
                aria-label="Legal"
                className="mx-auto flex flex-wrap items-center justify-center gap-x-5 gap-y-1 text-xs text-muted-foreground"
            >
                <button type="button" className={linkClasses} onClick={() => setAboutOpen(true)}>
                    About ESCloud
                </button>
                <Link to="/eifu" className={linkClasses}>
                    Instructions for Use
                </Link>
                <Link to="/declaration-of-conformity" className={linkClasses}>
                    Declaration of Conformity
                </Link>
                <Link to="/legal-notice" className={linkClasses}>
                    Legal Notice
                </Link>
                <Link to="/privacy-policy" className={linkClasses}>
                    Privacy Policy
                </Link>
            </nav>
            <AboutDialog open={aboutOpen} onOpenChange={setAboutOpen} />
        </footer>
    );
}
